import apiUrl from '../../../constants'
import axios from 'axios'
import Paginate from 'vuejs-paginate';
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css';
import VueElementLoading from 'vue-element-loading';
import { decryptData } from '../../../../utils/crypto_utils';

export default {
  name: 'srlevelreport',
  components: {
    Paginate,
    Multiselect,
    VueElementLoading
  },

  data() {
    return {
      isLoading: false,
      excelLoading: false,
      pagenoDayWise: 0,
      pageCountDayWise: 0,
      resultCountDayWise: 0,
      exportf: false,
      zoneLoading: false,
      zone: [],
      zoneList: [],
      fromDate: '',
      toDate: '',
      hubIdArr: [],
      srDayWisePending: [],
      reportlink: '',
      dateRangeError: ''
    }
  },

  computed: {
    dynamicDateHeaders() {
      if (!this.srDayWisePending || this.srDayWisePending.length === 0) {
        return [];
      }
      const keys = Object.keys(this.srDayWisePending[0]);
      const datePattern = /^\d{2}-\d{2}-\d{4}$/;
      const dateKeys = keys.filter(key => datePattern.test(key));
      dateKeys.sort((a, b) => {
        const partsA = a.split('-');
        const partsB = b.split('-');
        const dateA = new Date(partsA[2], partsA[1] - 1, partsA[0]);
        const dateB = new Date(partsB[2], partsB[1] - 1, partsB[0]);
        return dateB - dateA;
      });
      return dateKeys;
    }
  },

  mounted() {
    this.urltoken = window.localStorage.getItem('accessuserToken');
    this.getZoneData();
  },

  methods: {
    getPaginationDataDayWise(pageNum) {
      this.pagenoDayWise = (pageNum - 1) * 10;
      this.getSRDayWisePending();
    },

    onSubmit() {
      this.$validator.validateAll().then(valid => {
        if (!valid) return;
        this.dateRangeError = '';
        this.pagenoDayWise = 0;
        let diffTime = Math.abs(new Date(this.toDate) - new Date(this.fromDate));
        let diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

        if (this.fromDate > this.toDate) {
          this.dateRangeError = 'From date should not be greater than To date.';
          return false;
        } else if (diffDays > 15) {
          this.dateRangeError = 'Difference between From date & To date should not be greater than 15 days.';
          return false;
        }
        this.getSRDayWisePending();
      }).catch(() => {
        console.log('errors exist', this.errors);
      });
    },

    resetForm() {
      this.zone = [];
      this.fromDate = '';
      this.toDate = '';
      this.srDayWisePending = [];
      this.pagenoDayWise = 0;
      this.pageCountDayWise = 0;
      this.resultCountDayWise = 0;
      this.exportf = false;
      this.excelLoading = false;
      this.dateRangeError = '';
      if (this.$validator) {
        this.$validator.reset();
        this.errors.clear();
      }
    },

    getZoneData() {
      this.zoneLoading = true;
      try {
        const zonedata = window.localStorage.getItem('zonedata');
        const decryptedZoneData = decryptData(zonedata);
        this.zoneList = [{ hubzoneid: '0', hubzonename: 'All Zone', hubzonecode: 'All Zone' }].concat(decryptedZoneData || []);
      } catch (error) {
        console.error('Error loading zone data:', error);
      } finally {
        this.zoneLoading = false;
      }
    },

    addHubData() {
      this.hubIdArr = [];
      if (!this.zone || (Array.isArray(this.zone) && this.zone.length === 0)) {
        return;
      }

      try {
        const storedDataEncrypted = localStorage.getItem('zonewisehubdata');
        const hubdata = decryptData(storedDataEncrypted);
        if (!hubdata) {
          return;
        }

        const selectedZones = Array.isArray(this.zone) ? this.zone : [this.zone];
        const allSelected = selectedZones.some(z => String(z.hubzoneid) === '0');
        const zonesToUse = allSelected ? hubdata : selectedZones;
        const hubIds = new Set();

        zonesToUse.forEach(zoneItem => {
          const zoneRecord = hubdata.find(item => item.HubZoneId == zoneItem.hubzoneid);
          if (zoneRecord) {
            [...(zoneRecord.svcHubs || []), ...(zoneRecord.rscHubs || [])].forEach(hub => hubIds.add(hub.HubID));
          }
        });

        this.hubIdArr = Array.from(hubIds);
      } catch (error) {
        console.error('Error loading hub data:', error);
      }
    },

    exportSRDaywisePending() {
      this.isLoading = true;
      this.excelLoading = true;
      this.input = {
        hubid: this.hubIdArr,
        fromDate: this.fromDate,
        toDate: this.toDate
      };

      axios({
        method: 'POST',
        url: apiUrl.api_url + 'exportSRLevelSummary',
        data: this.input,
        headers: {
          'Authorization': 'Bearer ' + this.urltoken
        }
      }).then(result => {
        if (result.data.code == 200) {
          this.exportf = true;
          this.reportlink = result.data.presignFilePath;
          window.open(this.reportlink);
        } else {
          this.exportf = false;
          this.reportlink = '';
        }
      }).catch(error => {
        this.exportf = false;
        this.reportlink = '';
        console.error(error);
        this.$alertify.error('Error Occured');
      }).finally(() => {
        this.isLoading = false;
        this.excelLoading = false;
      });
    },

    exportSRDaywisePendingWithDispute() {
      this.isLoading = true;
      this.excelLoading = true;
      this.input = {
        hubid: this.hubIdArr,
        fromDate: this.fromDate,
        toDate: this.toDate
      };

      axios({
        method: 'POST',
        url: apiUrl.api_url + 'exportSRLevelDisputeSummary',
        data: this.input,
        headers: {
          'Authorization': 'Bearer ' + this.urltoken
        }
      }).then(result => {
        if (result.data.code == 200) {
          this.exportf = true;
          this.reportlink = result.data.presignFilePath;
          window.open(this.reportlink);
        } else {
          this.exportf = false;
          this.reportlink = '';
        }
      }).catch(error => {
        this.exportf = false;
        this.reportlink = '';
        console.error(error);
        this.$alertify.error('Error Occured');
      }).finally(() => {
        this.isLoading = false;
        this.excelLoading = false;
      });
    },

    getSRDayWisePending() {
      this.isLoading = true;
      this.input = {
        hubid: this.hubIdArr,
        fromDate: this.fromDate,
        toDate: this.toDate,
        offset: this.pagenoDayWise,
        limit: 10
      };

      axios({
        method: 'POST',
        url: apiUrl.api_url + 'getSRLevelSummary',
        data: this.input,
        headers: {
          'Authorization': 'Bearer ' + this.urltoken
        }
      }).then(result => {
        if (result.data.code == 200) {
          this.srDayWisePending = result.data.data || [];
          this.exportf = true;
          const total = result.data.pagination ? result.data.pagination.totalCount : 0;
          this.resultCountDayWise = total;
          this.pageCountDayWise = total > 0 ? Math.ceil(total / 10) : 0;
        } else {
          this.srDayWisePending = [];
          this.exportf = false;
          this.resultCountDayWise = 0;
          this.pageCountDayWise = 0;
        }
      }).catch(error => {
        this.srDayWisePending = [];
        this.exportf = false;
        this.resultCountDayWise = 0;
        this.pageCountDayWise = 0;
        console.error(error);
        this.$alertify.error('Error Occured');
      }).finally(() => {
        this.isLoading = false;
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/components/srlevelreport/srlevelreport.component.js